require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-developers-who-we-want-to-be.json") })
        }
      }, "path---blog-the-developers-who-we-want-to-be");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-developers-who-we-want-to-be!./.cache/json/blog-the-developers-who-we-want-to-be.json
// module id = 1079
// module chunks = 231608221292675